/**
 * Custom exception class for Flipper feature flag service errors.
 * Used to handle and identify errors specific to the Flipper feature flag system.
 * @extends {Error}
 */
export class FlipperException extends Error {
  public innerException: Error | null = null;

  constructor(message: string) {
    super(message);
    // Literal, because the production build minifies constructor names.
    this.name = 'FlipperException';
  }
}
